<input
  type="text"
  [placeholder]="placeholderChannelName"
  [(ngModel)]="name"
  (ngModelChange)="onNameChange($event)"
  (focus)="placeholderChannelName = ''"
  (blur)="placeholderChannelName = 'Channel name'"
  [ngStyle]="{
       'border-color' : validateChannelName() ? '#e1e6eb' : 'red'
       }"
/>
<textarea
  class="text-area-large"
  [placeholder]="placeholderChannelDescription"
  [ngModel]="description"
  (ngModelChange)="onDescriptionChange($event)"
  (focus)="placeholderChannelDescription = ''"
  (blur)="placeholderChannelDescription = 'Channel description'"
></textarea>

<div class="text">Choose the timezone to broadcast your channel:</div>
<icn-dropdown
  [selectedValue]="timezoneId"
  [position]="'bottom'"
  (selectedValueChange)="onTimezoneIdChange($event)"
  [large]="true"
>
  <icn-dropdown-item
    *ngFor="let timezone of getTimezones()"
    [title]="timezone.name"
    [value]="timezone.id"
  >
  </icn-dropdown-item>
</icn-dropdown>

<div class="small-dropdown">
  <div class="text display-inline">Main Language:</div>
  <icn-dropdown
    [(selectedValue)]="mainLanguageCode"
    (selectedValueChange)="onMainLanguageChange.emit($event)"
  >
    <icn-dropdown-item
      class="display-inline main-language-field"
      *ngFor="let lang of languages"
      [title]="lang.name"
      [value]="lang.code"
    >
    </icn-dropdown-item>
  </icn-dropdown>
</div>
<div class="audio-lang-fallback-settings">
  <div class="text">Audio Language Fallback Settings:</div>
  <div class="rows">
    <div
      class="audio-lang-row"
      *ngFor="
        let entry of audioLangSettings;
        let i = index;
        trackBy: trackEntryByIndex
      "
    >
      <icn-dropdown
        [selectedValue]="entry.languageCode"
        (selectedValueChange)="onEntryLanguageCodeChange(i, $event)"
      >
        <icn-dropdown-item
          *ngFor="let lang of getAvailableLanguagesFor(i)"
          [title]="lang.name"
          [value]="lang.code"
        >
        </icn-dropdown-item>
      </icn-dropdown>
      <div class="fallback-popup-wrapper">
        <button
          type="button"
          class="fallback-summary-btn"
          (click)="toggleFallbackPopup(i)"
        >
          <span class="fallback-summary-label">
            Fallbacks ({{ entry.audioFallbackLanguages?.length || 0 }})
          </span>
          <svg
            class="fallback-summary-chevron"
            viewBox="0 0 10 6"
            width="10"
            height="6"
          >
            <path d="M1 1l4 4 4-4" stroke="currentColor" fill="none" />
          </svg>
        </button>
        <div
          class="fallback-popover-content"
          [class.open]="openFallbackPopupIndex === i"
        >
          <div class="fallback-popover-header">
            <span>Fallback languages</span>
            <button
              type="button"
              class="fallback-popover-close"
              (click)="closeFallbackPopup()"
            >
              ×
            </button>
          </div>
          <p class="fallback-popover-hint">
            Drag to reorder. First language is tried first.
          </p>
          <div
            class="fallback-chip-list"
            cdkDropList
            cdkDropListOrientation="vertical"
            [cdkDropListData]="entry.audioFallbackLanguages"
            (cdkDropListDropped)="onFallbackLanguageDrop(i, $event)"
          >
            <div
              *ngFor="let code of entry.audioFallbackLanguages"
              class="fallback-chip"
              cdkDrag
              cdkDragLockAxis="y"
            >
              <div class="drag-handle">
                <svg viewBox="0 0 20 20" width="14" height="14">
                  <path
                    d="M17.5 8.33H2.5a.83.83 0 1 1 0-1.66h15a.83.83 0 1 1 0 1.66Zm.83 4.17a.83.83 0 0 1-.83.83H2.5a.83.83 0 1 1 0-1.66h15a.83.83 0 0 1 .83.83Z"
                    fill="currentColor"
                  />
                </svg>
              </div>
              <span class="chip-label">{{ getLanguageName(code) }}</span>
              <button
                type="button"
                class="chip-remove"
                (mousedown)="$event.stopPropagation()"
                (click)="removeFallbackLanguage(i, code); $event.stopPropagation()"
              >
                ×
              </button>
            </div>
            <div
              class="fallback-empty"
              *ngIf="!entry.audioFallbackLanguages?.length"
            >
              No fallback languages yet.
            </div>
          </div>
          <icn-dropdown
            class="fallback-add-dropdown"
            [placeholder]="'+ Add language'"
            [selectedValue]="fallbackPickerValues[i] || ''"
            (selectedValueChange)="addFallbackLanguage(i, $event)"
          >
            <icn-dropdown-item
              *ngFor="let lang of getAvailableFallbackLanguagesFor(i)"
              [title]="lang.name"
              [value]="lang.code"
            >
            </icn-dropdown-item>
          </icn-dropdown>
        </div>
      </div>
      <!--<div
        class="checkbox-input"
        [class.active]="entry.skipOriginalMediaAudioLanguage"
      >
        <div
          (click)="onEntrySkipOriginalChange(i, !entry.skipOriginalMediaAudioLanguage)"
        >
          <svg viewBox="0 0 21.02 14.02">
            <path
              fill-rule="evenodd"
              d="M21.498,2.349 L8.886,14.965 L0.479,6.555 L1.880,5.153 L8.886,12.161 L20.096,0.948 L21.498,2.349 Z"
            />
          </svg>
        </div>
        <span class="label">Skip original media language</span>
      </div>-->
      <button
        type="button"
        class="remove-btn"
        (click)="removeAudioLangSetting(i)"
      >
        ×
      </button>
    </div>
  </div>
  <ichannel-button
    [label]="'+ Add language'"
    [theme]="'DARK'"
    (click)="addAudioLangSetting()"
  ></ichannel-button>
</div>
<div class="small-dropdown">
  <div class="text">Choose your channel's language:</div>
  <div class="small-container">
    <div
      class="checkbox-input checkbox-input-burn-subs"
      [class.active]="burnSubtitlesToVideo"
    >
      <div (click)="onBurnSubtitlesToVideoChanged()">
        <svg viewBox="0 0 21.02 14.02">
          <path
            fill-rule="evenodd"
            d="M21.498,2.349 L8.886,14.965 L0.479,6.555 L1.880,5.153 L8.886,12.161 L20.096,0.948 L21.498,2.349 Z"
          />
        </svg>
      </div>
    </div>
    <span class="label-subs"> Burn subtitles into the video </span>
    <div class="subtitles-choose">
      <span class="label"> SUBTITLES: </span>
      <icn-dropdown
        class="popover-font-dropdown"
        [showSettingsIcon]="true"
        [selectedValue]="subtitleLanguage"
        (selectedValueChange)="onSubtitleLanguageChange($event)"
        (settingsIconClicked)="onOpenSettingsIcon($event, settingsPopover)"
        #subtitlesDropdown
      >
        <icn-dropdown-item
          *ngFor="let sub of languages"
          [title]="sub.name"
          [value]="sub.code"
        >
        </icn-dropdown-item>
      </icn-dropdown>
    </div>
  </div>
</div>
<pop-over
  #settingsPopover
  [my]="'top left'"
  [at]="'top right'"
  [y-offset]="-76"
  [x-offset]="20"
>
  <div class="subtitles-font-popover">
    <div class="triangle-with-shadow"></div>
    <div class="header-close-container">
      <header>Subtitles Settings</header>
      <div
        class="x-sign"
        [inlineSVG]="closeIcon"
        (click)="settingsPopover.hide(); $event.stopImmediatePropagation()"
      ></div>
    </div>
    <div class="field">
      <span class="label">FONT TYPE:</span>
      <icn-dropdown
        #fontTypeDropdown
        [selectedValue]="subtitlesSettings.fontId"
      >
        <icn-dropdown-item
          *ngFor="let font of fonts"
          [title]="font.name"
          [value]="font.id"
        >
        </icn-dropdown-item>
      </icn-dropdown>
    </div>
    <div class="field">
      <span class="label">Subtitle start position from top:</span>
      <div class="number-input">
        <icn-number-input
          #subtitleStartPositionFromTop
          [min]="0"
          [max]="(subtitleEndPositionFromTop.value) - 0.5"
          [maxLength]="3"
          [sign]="'%'"
          [step]="0.5"
          [contentEditable]="false"
          [value]="subtitlesSettings.subtitleStartPositionFromTop"
        ></icn-number-input>
      </div>
    </div>
    <div class="field">
      <span class="label">Subtitle end position from top:</span>
      <div class="number-input">
        <icn-number-input
          #subtitleEndPositionFromTop
          [min]="(subtitleStartPositionFromTop.value) + 0.5"
          [max]="100"
          [sign]="'%'"
          [maxLength]="3"
          [step]="0.5"
          [contentEditable]="false"
          [value]="subtitlesSettings.subtitleEndPositionFromTop"
        ></icn-number-input>
      </div>
    </div>
    <ichannel-button
      [label]="'Save'"
      [theme]="'DARK'"
      (click)="onSubtitleSettingsSave(settingsPopover,
                                                fontTypeDropdown.selectedValue,
                                                subtitleStartPositionFromTop.value,
                                                subtitleEndPositionFromTop.value)"
    ></ichannel-button>
  </div>
</pop-over>
<label class="DVB-comment" *ngIf="!burnSubtitlesToVideo"
  >* you can add DVB subtitles in the next step</label
>
<div class="small-dropdown">
  <div class="small-container">
    <div class="subtitles-choose">
      <span class="label"> CLOSED CAPTIONS: </span>
      <icn-dropdown
        class="popover-font-dropdown"
        [allowMultiple]="true"
        [showSettingsIcon]="true"
        [selectedValues]="selectedClosedCaptionLanguages"
        (selectedValuesChange)="onClosedCaptionLanguagesChange($event)"
        (settingsIconClicked)="
          onOpenClosedCaptionSettings($event, ccSettingsPopover)
        "
        #closedCaptionsDropdown
      >
        <icn-dropdown-item
          *ngFor="let l of languages"
          [title]="l.name"
          [value]="l.code"
        >
        </icn-dropdown-item>
      </icn-dropdown>
    </div>
  </div>
</div>
<pop-over
  #ccSettingsPopover
  [my]="'top left'"
  [at]="'top right'"
  [y-offset]="-76"
  [x-offset]="20"
>
  <div class="subtitles-font-popover" *ngIf="getEditingClosedCaption()">
    <div class="triangle-with-shadow"></div>
    <div class="header-close-container">
      <header>Closed Caption Settings</header>
      <div
        class="x-sign"
        [inlineSVG]="closeIcon"
        (click)="ccSettingsPopover.hide(); $event.stopImmediatePropagation()"
      ></div>
    </div>
    <div class="field">
      <span class="label">TRANSPORT:</span>
      <icn-dropdown
        #ccTransportDropdown
        [selectedValue]="getEditingClosedCaption().captionsTransport"
      >
        <icn-dropdown-item
          *ngFor="let opt of captionsTransportOptions"
          [title]="opt.name"
          [value]="opt.value"
        >
        </icn-dropdown-item>
      </icn-dropdown>
    </div>
    <div class="field">
      <span class="label">TYPE:</span>
      <icn-dropdown
        #ccTypeDropdown
        [selectedValue]="getEditingClosedCaption().captionsType"
      >
        <icn-dropdown-item
          *ngFor="let opt of captionsTypeOptions"
          [title]="opt.name"
          [value]="opt.value"
        >
        </icn-dropdown-item>
      </icn-dropdown>
    </div>
    <div class="field">
      <span class="label">Service number:</span>
      <div class="number-input">
        <icn-number-input
          #ccServiceNumber
          [min]="0"
          [max]="63"
          [maxLength]="2"
          [step]="1"
          [contentEditable]="false"
          [value]="getEditingClosedCaption().captionsServiceNumber"
        ></icn-number-input>
      </div>
    </div>
    <ichannel-button
      [label]="'Save'"
      [theme]="'DARK'"
      (click)="
        onClosedCaptionSettingsSave(
          ccSettingsPopover,
          ccTransportDropdown.selectedValue,
          ccTypeDropdown.selectedValue,
          ccServiceNumber.value
        )
      "
    ></ichannel-button>
  </div>
</pop-over>
<div class="small-dropdown">
  <div class="text">Choose milliseconds or frame rates:</div>
  <div class="small-container">
    <div>
      <icn-dropdown
        [medium]="true"
        [selectedValue]="!!framerate ? 'fps' : 'ms'"
        (selectedValueChange)="msOrFpsChange($event)"
      >
        <icn-dropdown-item [title]="'MS'" [value]="'ms'"> </icn-dropdown-item>
        <icn-dropdown-item [title]="'FPS'" [value]="'fps'"> </icn-dropdown-item>
      </icn-dropdown>
    </div>
    <div class="spread" *ngIf="!!framerate">
      <icn-dropdown
        [large]="true"
        [selectedValue]="framerate"
        (selectedValueChange)="onFramerateChange($event)"
      >
        <icn-dropdown-item title="23.976" [value]="23.976"></icn-dropdown-item>
        <icn-dropdown-item title="24" [value]="24"></icn-dropdown-item>
        <icn-dropdown-item
          title="25 - Default for Israel & Europe"
          [value]="25"
        ></icn-dropdown-item>
        <icn-dropdown-item title="29.97" [value]="29.97"></icn-dropdown-item>
        <icn-dropdown-item
          title="30 - Default for the US & Japan"
          [value]="30"
        ></icn-dropdown-item>
        <icn-dropdown-item title="50" [value]="50"></icn-dropdown-item>
        <icn-dropdown-item title="59.94" [value]="59.94"></icn-dropdown-item>
        <icn-dropdown-item title="60" [value]="60"></icn-dropdown-item>
      </icn-dropdown>
    </div>
  </div>
</div>
<div class="small-dropdown">
  <div class="text">Choose aspect ratio:</div>
  <div class="small-container">
    <div>
      <icn-dropdown
        [medium]="true"
        [selectedValue]="aspectRatio"
        (selectedValueChange)="onAspectRatioChange($event)"
      >
        <icn-dropdown-item title="16:9" [value]="1"> </icn-dropdown-item>
        <icn-dropdown-item title="4:3" [value]="2"> </icn-dropdown-item>
        <icn-dropdown-item title="1:1" [value]="3"> </icn-dropdown-item>
      </icn-dropdown>
    </div>
  </div>
</div>
<div></div>
<div class="small-dropdown">
  <div class="text display-inline" style="margin: 1px 0">
    Live Show Extend Behaviour:
  </div>
  <icn-dropdown
    [selectedValue]="autoExtendLiveShowBehaviour"
    (selectedValueChange)="updateAutoExtendLiveShowBehaviour($event)"
  >
    <icn-dropdown-item
      title="No extension of live show"
      [value]="EAutoExtendLiveShowBehaviour.Empty"
    ></icn-dropdown-item>
    <icn-dropdown-item
      title="Auto extend live show"
      [value]="EAutoExtendLiveShowBehaviour.EndlesslyExtendLiveShow"
    ></icn-dropdown-item>
  </icn-dropdown>
  <p class="bottom-margin-10px">
    <small
      *ngIf="autoExtendLiveShowBehaviour === EAutoExtendLiveShowBehaviour.EndlesslyExtendLiveShow"
    >
      * The live show will continue playing automatically until you choose to
      skip.
    </small>
  </p>
</div>
<div class="upload-playlist-settings-fields">
  <div class="text">Upload Playlist CSV settings:</div>

  <div class="fields">
    <div class="playlist-upload-hours-ahead-field">
      <div class="checkbox-input" [class.active]="allowedHoursFromNowSelected">
        <div (click)="allowedHoursFromNowChecked()">
          <svg viewBox="0 0 21.02 14.02">
            <path
              fill-rule="evenodd"
              d="M21.498,2.349 L8.886,14.965 L0.479,6.555 L1.880,5.153 L8.886,12.161 L20.096,0.948 L21.498,2.349 Z"
            />
          </svg>
        </div>
        <span class="label">
          Playlist upload hours ahead
          <icn-number-input
            [contentEditable]="allowedHoursFromNowSelected"
            [step]="1"
            [minLength]="0"
            [maxLength]="20000000"
            [useDefaultHtmlInput]="true"
            [(value)]="uploadPlaylistCsvSettings.allowedHoursFromNow"
          ></icn-number-input>
        </span>
      </div>
    </div>
    <!--<div class="checkbox-input" [class.active]="uploadPlaylistCsvSettings.allowToOverrideNowPlayingShow">
      <div (click)="uploadPlaylistCsvSettings.allowToOverrideNowPlayingShow = !uploadPlaylistCsvSettings.allowToOverrideNowPlayingShow">
        <svg viewBox="0 0 21.02 14.02">
          <path fill-rule="evenodd"
                d="M21.498,2.349 L8.886,14.965 L0.479,6.555 L1.880,5.153 L8.886,12.161 L20.096,0.948 L21.498,2.349 Z"/>
        </svg>
      </div>
      <span class="label">
                    Allow To Override What's Playing Now
        </span>
    </div>-->
    <!--<div class="checkbox-input" [class.active]="uploadPlaylistCsvSettings.allowToUploadHistoricalPlaylist">
      <div (click)="uploadPlaylistCsvSettings.allowToUploadHistoricalPlaylist = !uploadPlaylistCsvSettings.allowToUploadHistoricalPlaylist">
        <svg viewBox="0 0 21.02 14.02">
          <path fill-rule="evenodd"
                d="M21.498,2.349 L8.886,14.965 L0.479,6.555 L1.880,5.153 L8.886,12.161 L20.096,0.948 L21.498,2.349 Z"/>
        </svg>
      </div>
      <span class="label">
                    Allow To Upload Historical Playlist
        </span>
    </div>-->
    Media Id prefixes to alert:
    <input
      type="text"
      placeholder="Type here comma-separated prefixes"
      value="{{extractMediaIds(uploadPlaylistCsvSettings.mediaIdPrefixesToAlert)}}"
      (change)="onMediaIdsFieldChange($event)"
    />
    <div></div>
    <span> Allowed playlist file names(With wildcard)</span>
    <input
      type="text"
      placeholder="Currently all file names are allowed"
      [(ngModel)]="uploadPlaylistCsvSettings.allowedFileNameWildcard"
    />
  </div>
</div>
<div class="playback-offset-field">
  Playback offset(ms):
  <icn-number-input
    [step]="1000"
    [minLength]="-20000000"
    [maxLength]="20000000"
    [useDefaultHtmlInput]="true"
    [(value)]="playbackOffset"
    (valueChange)="playbackOffsetChanged.emit($event)"
  ></icn-number-input>
</div>
<div class="playback-offset-field">
  Scheduler days to load:
  <icn-number-input
    [step]="1"
    [min]="1"
    [max]="31"
    [minLength]="1"
    [maxLength]="31"
    [useDefaultHtmlInput]="true"
    [(value)]="channelInfo.schedulerDaysToLoad"
  ></icn-number-input>
</div>
<div>
  <div class="checkbox-input" [class.active]="playSingleItemPerDepth">
    <div (click)="playSingleItemPerDepthChangedEventHandler()">
      <svg viewBox="0 0 21.02 14.02">
        <path
          fill-rule="evenodd"
          d="M21.498,2.349 L8.886,14.965 L0.479,6.555 L1.880,5.153 L8.886,12.161 L20.096,0.948 L21.498,2.349 Z"
        />
      </svg>
    </div>
    <span class="label"> Play single media item per depth </span>
  </div>
</div>
<div>
  <div
    class="checkbox-input"
    [class.active]="cuePeriodChecked"
    [class.readonly]="hasCuePeriodOnCommand()"
  >
    <div (click)="toggleCuePeriod()">
      <svg viewBox="0 0 21.02 14.02">
        <path
          fill-rule="evenodd"
          d="M21.498,2.349 L8.886,14.965 L0.479,6.555 L1.880,5.153 L8.886,12.161 L20.096,0.948 L21.498,2.349 Z"
        />
      </svg>
    </div>
    <span class="label"> Cueperiod setting </span>
  </div>
</div>
<div>
  <div class="checkbox-input" [class.active]="audioNormalizationChecked">
    <div (click)="toggleAudioNormalization()">
      <svg viewBox="0 0 21.02 14.02">
        <path
          fill-rule="evenodd"
          d="M21.498,2.349 L8.886,14.965 L0.479,6.555 L1.880,5.153 L8.886,12.161 L20.096,0.948 L21.498,2.349 Z"
        />
      </svg>
    </div>
    <span class="label"> AUDIO NORMALIZATION: </span>
    <input
      [class.not-visible]="!audioNormalizationChecked"
      type="number"
      [ngModel]="audioNormalizationValue"
      (ngModelChange)="onAudioNormalizationValueChange($event)"
      [disabled]="!audioNormalizationChecked"
      max="0"
      min="-30"
    />
    <span class="label-black" [class.not-visible]="!audioNormalizationChecked"
      >DB</span
    >
  </div>
  <div
    class="checkbox-input use-lufs-field"
    [class.not-visible]="!audioNormalizationChecked"
    [class.active]="lufsChecked"
  >
    <div (click)="toggleLUFS()">
      <svg viewBox="0 0 21.02 14.02">
        <path
          fill-rule="evenodd"
          d="M21.498,2.349 L8.886,14.965 L0.479,6.555 L1.880,5.153 L8.886,12.161 L20.096,0.948 L21.498,2.349 Z"
        />
      </svg>
    </div>
    <span class="label"> USE LUFS </span>
  </div>
  <div>
    <div
      class="checkbox-input"
      [class.active]="channelIsRecordingActiveChecked"
    >
      <div (click)="toggleIsRecordingActiveChanged()">
        <svg viewBox="0 0 21.02 14.02">
          <path
            fill-rule="evenodd"
            d="M21.498,2.349 L8.886,14.965 L0.479,6.555 L1.880,5.153 L8.886,12.161 L20.096,0.948 L21.498,2.349 Z"
          />
        </svg>
      </div>
      <span class="label">
        Low resolution 24x7 Recording for legal purposes
      </span>
    </div>
  </div>
  <div class="scte-tags">
    <autocomplete
      [position]="'top'"
      [inputLabel]="'SCTE TAGS:'"
      [inputPlaceholder]="'Add Tags'"
      [feedWithEnter]="false"
      [values]="availableTags"
      [excludes]="tags"
      [key]="'name'"
      [visible]="false"
      (output)="addNewTag($event)"
      (outputNewValue)="createNewTag($event)"
    ></autocomplete>
    <tags-wrapper
      [tags]="tags"
      (onDeleteTag)="deleteExistTag($event)"
    ></tags-wrapper>
    <div class="scte-command-field" *ngIf="channelInfo.scteTagIds.length > 0">
      <span class="label">Choose SCTE command:</span>

      <icn-dropdown
        [medium]="true"
        [(selectedValue)]="channelInfo.scteOutCommandId"
      >
        <icn-dropdown-item
          *ngFor="let scteCommand of availableScteCommands"
          [value]="scteCommand.id"
          [title]="scteCommand.commandName"
          [showSettings]="false"
        >
        </icn-dropdown-item>
      </icn-dropdown>
    </div>
  </div>

  <!--<div *ngIf="isSuperUser">

    <div class="checkbox-input" [class.active]="channelAsTemplateChecked">
        <div (click)="toggleAsTemplatedChanged()">
            <svg viewBox="0 0 21.02 14.02">
                <path fill-rule="evenodd"
                      d="M21.498,2.349 L8.886,14.965 L0.479,6.555 L1.880,5.153 L8.886,12.161 L20.096,0.948 L21.498,2.349 Z"/>
            </svg>
        </div>
        <span class="label">
                    SET CHANNEL AS TEMPLATE:
        </span>
    </div>

    <div class="text">
        Choose template categories:
    </div>
    <icn-dropdown
            [class.disabled]="!channelAsTemplateChecked"
            [disabled]="!channelAsTemplateChecked"
            [allowMultiple]="true"
            [selectedValues]="selectedChannelCategories"
            [large]="true">
        <icn-dropdown-item
                *ngFor="let category of allCategories"
                [title]="category.name"

                [value]="category.id">
        </icn-dropdown-item>
    </icn-dropdown>


    <div class="text">
        Trailer URL:
    </div>
    <input [class.disabled]="!channelAsTemplateChecked"
           type="text"
           (change)="templateTrailerUrlChanged.emit($event.target.value)"
           [ngModel]="templateTrailerUrl"
           [disabled]="!channelAsTemplateChecked"/>

</div>
--></div>
